<template>
  <button-popout
    :value="(value as T)"
    :options="options"
    class="button-icon net-visibility-button-select"
    y-alignment="bottom"
    :non-closing-elements="nonClosingElements"
    @update:value="$emit('update:value', $event)"
  >
    <template #default="{ value: displayMode }">
      <template v-if="displayMode == 'visible'"><lucide-icon name="eye" /></template>
      <template v-else-if="displayMode == 'hidden'"><lucide-icon name="eye-off" /></template>
      <template v-else-if="displayMode == 'compact'"><lucide-icon name="chevrons-right-left" /></template>
      <template v-else-if="displayMode == 'endpoints'"><lucide-icon name="chevron-last" /></template>

      <template v-else-if="displayMode == 'value'"><lucide-icon name="git-commit-horizontal" /></template>
      <template v-else-if="displayMode == 'impacts'"><lucide-icon name="arrow-right" /></template>
    </template>

    <template #option="{ value: displayMode, select }">
      <button type="button" class="net-visibility-button-select__option" @click="select($event, displayMode)">
        <span style="font-size: 1.25rem; text-align: center;">
          <template v-if="displayMode == 'visible'"><lucide-icon name="eye" /></template>
          <template v-else-if="displayMode == 'hidden'"><lucide-icon name="eye-off" /></template>
          <template v-else-if="displayMode == 'compact'"><lucide-icon name="chevrons-right-left" /></template>
          <template v-else-if="displayMode == 'endpoints'"><lucide-icon name="chevron-last" /></template>

          <template v-else-if="displayMode == 'value'"><lucide-icon name="git-commit-horizontal" /></template>
          <template v-else-if="displayMode == 'impacts'"><lucide-icon name="arrow-right" /></template>
        </span>
        <span><slot :value="displayMode"></slot></span>
      </button>
    </template>
  </button-popout>
</template>

<script setup lang="ts" generic="T extends (VisibilityOption | DisplayMode)">
import ButtonPopout from '@core/input/ButtonPopout.vue';
import LucideIcon from '@core/ui/LucideIcon.vue';

export type VisibilityOption = "visible" | "hidden" | "compact" | "endpoints";
export type DisplayMode = "hidden" | "value" | "impacts";

withDefaults(defineProps<{
  options: T[];
  value: T;
  nonClosingElements?: HTMLElement[];
}>(), {
  nonClosingElements: () => []
});

defineEmits<{
  (event: "update:value", value: T): void;
}>();
</script>

<style lang="scss">
.net-visibility-button-select {
  &__option {
    text-align: left;
    border: none;
    background-color: var(--color-background-close);
    display: grid;
    grid-template-columns: 1.5rem 1fr;
    font-size: 1rem;
    padding: 0.25rem 0.5rem;
    padding-right: 0.75rem;
    gap: 0.5rem;

    &:hover {
      background-color: var(--color-action);
      color: var(--color-action-contrast);
    }
  }
}
</style>